import React, {  Component } from 'react'
import ReactDOM from 'react-dom/client';
import avtlogo from "./img/avt.png"; 
import Apprt from './App';
//import AdmDashboard from './components/AdminDashboard.js';
import './assets/css/homestyle.css'
import axios from 'axios';
import { removeUserSession, setUserSession,aPIURL,auTHURL } from './utils/common.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CDashboard from './components/ClientApplication/CDashboard';
import Modal from './components/LoginModal';
import PriceList from './components/PriceList.js';
import PublicNav from './Shared/PublicNav.js'
import PublicFooter from './Shared/PublicFooter.js'
import $ from 'jquery';
import bvideo from './img/AVT-banner.mp4';
import Blog from './Blog.js';
import ReactPlayer from 'react-player/youtube'
import ForgetPassword from './components/ForgetPassword.js';

let isst=false;
class AvtHome extends React.Component 
{
  
  constructor(props) 
  {
    
    super(props);    
    this.state = {
     showLogin: false, 
     showForgetPassword:false,  
     showSendOtpBtn:false,
     showResendOtpBtn:true, 
     showResetPassword:false,
     fpOtp:"",
     pVisible: false,
      message:'',
      logInfo:{
                UserName: "",
                Password: ""
             },
      contactInfo:{
              ContactName: "",
              ContactMobile:"",
              ContactEmail: "",
              ContactMessage:""
          },
          forgetPasswordInfo:{
                fMobile: "",
                fOtp: "",
                fnewPassword: "",
                fconfirmPassword: ""              
          }
    };
     
  }
  

  onClickLogin=()=>{
      
   
      if(!this.state.logInfo.UserName)
      {
          toast.error("User name is required.",{ position: "bottom-right", autoClose: 4000, theme: "light"});
          
          return;
      }
      else  if(!this.state.logInfo.Password)
      {
          toast.error("Password is required.",{ position: "bottom-right", autoClose: 4000, theme: "light"});
          return;
      }
      else
      {
      const params = JSON.stringify({

        "Username": this.state.logInfo.UserName,
        "Password": this.state.logInfo.Password,
        "Role": "Customer",
        "UserType": "Admin",
            
      });
      const AUTH_URL=auTHURL();
     
         ///alert(AUTH_URL+'login');
        axios.post(AUTH_URL+'login', params,{        
              "headers": {          
              "content-type": "application/json",          
          },          
          })
          .then(function(response) 
          {
                 
                  console.log("--------------start-------------------");  
                //  console.log(response.data);            
                  if(JSON.parse(JSON.stringify(response.data.message))==='Logged in')
                  {
                          setUserSession(response.data.token, response.data.userName,response.data.userRole,response.data.actorID,response.data.name,response.data.customerTypeId);
                          const root = ReactDOM.createRoot(document.getElementById('root'));                          
                          root.render(<Apprt/>);
                          //if(response.data.userRole== 'Admin')
                          //{                            
                            //root.render(<Apprt/>);
                          //}
                          //else
                          //{
                            //root.render(<Apprt/>);
                          //}                            
                  }   
                  else
                  {       
                          removeUserSession();
                          console.log("---------Error----------");
                          //console.log(response.data.message);
                          toast.error(response.data.message,{ position: "bottom-right", autoClose: 4000, theme: "light"});                         
                  }           
           })
          
          .catch(function(error) 
          {
                  removeUserSession();
                 // alert(error);
                  toast.error(error,{ position: "bottom-right", autoClose: 4000, theme: "light"});   
                 // alert(JSON.stringify(error.data));
                  console.log(error);
          
          });
                      //  console.log(this.state.logInfo)
        }
  }

  onClickSendMessage=()=>
  {
        if(!this.state.contactInfo.ContactName)
        {
            toast.error("Name is required.",{ position: "bottom-right", autoClose: 4000, theme: "light"});
            return;
        }
        else  if(!this.state.contactInfo.ContactMobile)
        {
            toast.error("Mobile number is required.",{ position: "bottom-right", autoClose: 4000, theme: "light"});
            return;
        }
        else  if(!this.state.contactInfo.ContactEmail)
        {
            toast.error("Email is required.",{ position: "bottom-right", autoClose: 4000, theme: "light"});
            return;
        }
        else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.contactInfo.ContactEmail))
        {
              toast.error("Email is invalid.");
              return;
        } 
        else  if(!this.state.contactInfo.ContactMessage)
        {
            toast.error("Message is required.",{ position: "bottom-right", autoClose: 4000, theme: "light"});
            return;
        }
        else
        {
          let ContactmessageBody=`New Enquiry From  ${this.state.contactInfo.ContactName} \n ,Mobile No - ${this.state.contactInfo.ContactMobile} ,\n Email ID - ${this.state.contactInfo.ContactEmail} and \n Message - ${this.state.contactInfo.ContactMessage}. Thanks AVT.`;
          const params = JSON.stringify({
            
            "recipientEmail": "contact@avaalavt.com,sales@avaalbharat.com",
            "subject": "AVT Enquiry",
            "body": ContactmessageBody,
            "message": "Test Message from AVT",
            "from": "support@avaalavt.com",
            "host": " smtp.ionos.com ",
            "port": 587,
            "username": "support@avaalavt.com",
            "password": "Thrill-Reroute-Mashing4",
        });
        
        const API_URL=aPIURL();
        axios.post(API_URL+'MailService/', params,{
            "headers": {
            "content-type": "application/json",
            },
            })
            .then(function(response)
            { 
              
                    console.log("--------------start-------------------");
                    //console.log(response.data);
                    if(JSON.parse(JSON.stringify(response.data.validStatus))===true)
                    {                    
                             toast.success("Details submitted successfully. Our team will contact you shortly.",{ position: "bottom-right", autoClose: 4000, theme: "light"});                                  
                    }
                    else
                    {
                           toast.error(response.data.message,{ position: "bottom-right", autoClose: 4000, theme: "light"});
                    }
             })
            .catch(function(error)
            {
                    console.log(error.message);
            });
                      console.log(this.state.contactInfo)
          }         
  }

  onClickForgetPassword=()=>{     
     
     this.setState({ showLogin: false });
     this.setState({ showForgetPassword: true });
     this.setState({ showSendOtpBtn: false });  
     this.setState({ showResendOtpBtn: true });
    
  }
  closeForgetPassword=()=>{

     this.setState({ showLogin: false });
     this.setState({ showForgetPassword: false });
  }
changeHandler=e=>{
      
     const name=e.target.name;
     const value= e.target.value;

     this.setState({
              logInfo:{
                   ...this.state.logInfo,
                   [name]:value
              }}
     );     
}
changeCHandler=e=>{
  const name=e.target.name;
  const value= e.target.value;
  if(e.target.name==='ContactMobile')
  {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) 
        {
              this.setState({
                  contactInfo:{
                ...this.state.contactInfo,
                [name]:value
           }} );
        }
        else
        {
          this.setState({
                  contactInfo:{
                ...this.state.contactInfo,
                ['ContactMobile']: ""
           }} );          
              
        }

      }
      else
      {
            this.setState({
                  contactInfo:{
                ...this.state.contactInfo,
                [name]:value
           }} );
        }
}

changeFPHandler=e=>{
  const name=e.target.name;
  const value= e.target.value;
  this.setState({
            forgetPasswordInfo:{
                ...this.state.forgetPasswordInfo,
                [name]:value
           }}
  );
}

showLoginModal = () => {        
   
     this.setState({ showLogin: true });

}
closeLoginModal = () => {
     this.setState({ showLogin: false });
     this.setState({ showForgetPassword: false });     
    
}

showPage=()=>
    {
      const root = ReactDOM.createRoot(document.getElementById('root'));
      root.render(<PriceList/>);
    }
    handleUsernameKeyDown(event) {
      if (event.keyCode === 13) {
        document.getElementById('Password').focus();
      }
    }
    handlePasswordKeyDown(event) {
      if (event.keyCode === 13) {
          document.getElementById('signin').focus();
          //this.onClickLogin();
      }
    }
    showBlog=()=>
      {
        const root = ReactDOM.createRoot(document.getElementById('root'));
        root.render(<Blog/>);
      }   
   setVisible=()=>
     {
            if(this.state.pVisible)
            {
                    this.setState({ pVisible: false });
            }
            else
             {
                    this.setState({ pVisible: true });
            }
     }
    
   /* componentDidMount() 
    {
        $('.faq-wrapper h4').next('div').css('display', 'none');
            $('.faq-wrapper h4').click(function (event) {
                event.preventDefault();
                if ($(this).hasClass('open')) {
                    $(this).next('div').slideUp(20000);
                    $(this).removeClass('open');
                }
                else {
                    $('.faq-wrapper h4.open').next('div').slideUp(20);
                    $('.faq-wrapper h4.open').removeClass('open');
                    $(this).next('div').slideDown(20);
                    $(this).addClass('open');
                }
            });
      
  };
     */

  render() 
  {
       
     return (
      <>       

<header id="header" class="">
  <div class="container d-flex align-items-center header-center justify-content-between"> 
  <a href="index.html" class="logo"> <img src="../img/avt.png" alt="AVT" class="img-fluid"/> </a> 

  <ul class="navbar-nav avt-top-menu collapse" id='topMenu'>
        <li class="nav-item"> <a class="active" aria-current="page" href="#home">Home</a> </li>
        <li class="nav-item"> <a href="#pricing">Pricing</a> </li>
        <li class="nav-item"> <a href="#contact">Contact</a> </li>
        <li><a href="#" onClick={this.showBlog}>Blog</a></li>      
  </ul>
    <div class="logo-right-list">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#topMenu" aria-controls="topMenu" aria-expanded="false" aria-label="Toggle navigation">
    <span></span>
    <span></span>
    <span></span>
    </button>
    <span onClick={this.showLoginModal}  href="LoginPage" class="btn">Sign In</span>
    
    </div>
  </div>
</header>
<section class="banner topsection" id="home">
<video autoPlay loop muted>
    <source src={bvideo} type="video/mp4"/>
  </video>  
  <div class="container"> </div>
</section>
<section>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="title2 text-dark-blue mb-4 top-heading-line">Innovative Tracking Solutions,<br/>
          Unmatched Peace of Mind</h2>
        <p>AVAAL vehicle tracking (AVT) system provides a wide range of GPS solutions for your commercial trucks with advanced monitoring. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
      </div>
      <div class="col-md-6"> <img src="../img/img_r.png" class="img-fluid" alt="Innovative Tracking Solutions"/> </div>
    </div>
  </div>
</section>
<section class="ourFeature">
  <div class="container">
    <h2 class="title2 text-start mb-40 text-white">Our Features</h2>
    <div class="row">
      <div class="col-md-3">
        <div class="efficient-wrap text-start mb-40 text-white"> <img src="../img/update.png" alt="Realtime update" class="mb-10"/>
          <h5 class="title5 mb-10 text-white">Realtime update</h5>
          <p>Get real-time update of Vehicle at every 10 seconds</p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="efficient-wrap text-start mb-40 text-white"> <img src="../img/rewind.png" alt="Route Playback" class="mb-10"/>
          <h5 class="title5 mb-10 text-white">Route Playback</h5>
          <p>Play the precise routes taken by your vehicle</p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="efficient-wrap text-start mb-40 text-white"> <img src="../img/mileage.png" alt="Daily Mileage" class="mb-10"/>
          <h5 class="title5 mb-10 text-white">Daily Mileage</h5>
          <p>See estimate mileage and fuel efficiency of your vehicle</p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="efficient-wrap text-start mb-40 text-white"> <img src="../img/mileage.png" alt="Geo Fencing Alerts" class="mb-10"/>
          <h5 class="title5 mb-10 text-white">Geo Fencing Alerts</h5>
          <p>Set and get alerts vehicle incoming or outgoing specified area or radius</p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="efficient-wrap text-start mb-40 text-white"> <img src="../img/car-services.png" alt="Automated Alerts" class="mb-10"/>
          <h5 class="title5 mb-10 text-white">Automated Alerts</h5>
          <p>Manage, set and receive automated alerts about various events</p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="efficient-wrap text-start mb-40 text-white"> <img src="../img/fuel.png" alt="Fuel Monitoring" class="mb-10"/>
          <h5 class="title5 mb-10 text-white">Fuel Monitoring</h5>
          <p>AVAAL vehicle tracking (AVT) system provides a wide range of GPS solutions for your commercial trucks with advanced monitoring. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="efficient-wrap text-start mb-40 text-white"> <img src="../img/remote-control.png" alt="Control Vehicle" class="mb-10"/>
          <h5 class="title5 mb-10 text-white">Control Vehicle</h5>
          <p>You can remotely control your vehicle and shutdown engine if needed</p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="efficient-wrap text-start mb-40 text-white"> <img src="../img/live-traffic.png" alt="Live Traffic Updated" class="mb-10"/>
          <h5 class="title5 mb-10 text-white">Live Traffic Updated</h5>
          <p>Show status of Traffic on maps. Available only on Google Maps</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="container">
    <h2 class="title2 text-center mb-40 all-heading-line">Industries we Cover</h2>
    <div class="row">
      <div class="col-md-3 mb-20">
        <div class="card border-0">
          <div class="card-body p-0 text-center"> <img src="../img/fleet.jpg" alt="Fleet Vehicle Tracking" class="mb-10"/>
            <h5 class="title5 mt-10">Fleet Vehicle Tracking</h5>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-20">
        <div class="card border-0">
          <div class="card-body p-0 text-center"> <img src="../img/logistic.jpg" alt="Logistics Transport" class="mb-10"/>
            <h5 class="title5 mt-10">Logistics Transport</h5>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-20">
        <div class="card border-0">
          <div class="card-body p-0 text-center"> <img src="../img/public.jpg" alt="Public Transport" class="mb-10"/>
            <h5 class="title5 mt-10">Public Transport</h5>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-20">
        <div class="card border-0">
          <div class="card-body p-0 text-center"> <img src="../img/school.jpg" alt="School Bus" class="mb-10"/>
            <h5 class="title5 mt-10">School Bus</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section  id="pricing" class="bg-light">
  <div class="container">
    <h2 class="title2 text-center mb-15 all-heading-line">Pricing</h2>
    <h2 class="title4 text-center mb-10">A leading Vehicle Tracking Service Provider</h2>
    <p class="text-center">We believe in upfront and transparent pricing. That's why we've outlined our most popular plans below.<br/>
      These plans include the device itself, yearly services fees and key features.</p>
    <div class="row align-items-center" style={{ padding:"30px", boxShadow: "0 .5rem 1rem rgba(0, 0, 0, .15)"}}>
      <div class="col-md-6 col-lg-7">
        <h4>AVT-100 (2G)</h4>
        <p style={{textAlign:"justify"}}> There are dedicated GPS tracking devices available in the market that you can attach to vehicles, or containers you want to track. These devices usually come with their own software or apps that allow you to monitor their location in real-time. AVT 100 (2G) provide the latest technology devices to save on data, battery consumption and provides precise tracking and provides following features.</p>
        <p style={{textAlign:"justify"}}><b>Live Update :-</b>GPS live update provides continuous, real-time tracking of a device’s location for instant visibility and monitoring.</p>
        <p><b>Engine ON/OFF:-</b>Allows remote ignition management for enhanced security.</p>
        <p><b>Trip History:–</b>Logs past routes, stops, and travel durations for easy review.</p>
        <p><b>Parking Alert:–</b>Notifies when a vehicle is parked or moved unexpectedly.</p>
        <h5>Plan</h5>
        <ul class="btn-list d-flex">
          <li class="active">1 Year Plan</li>
          <li class="active" >2 Year Plan</li>
          <li class="active">3 Year Plan</li>
        </ul>
        <p>&#8377; <strong id="priceVal">2900</strong> <small class="d-inline">+GST</small> &nbsp;&nbsp;
        &#8377; <strong id="priceVal">5000</strong> <small class="d-inline">+GST</small> &nbsp;&nbsp;
        &#8377; <strong id="priceVal">6600</strong> <small class="d-inline">+GST</small></p>
      </div>
      <div class="col-md-6 col-lg-5 text-center"> <img src="../img/avt100.png" style={{width:"161px", height:"450px"}} class="gpsDevices img-fluid" alt="AVT 100" /> </div>
    </div>
    <br/>
    <div class="row align-items-center" style={{ padding:"30px",  boxShadow: "0 .5rem 1rem rgba(0, 0, 0, .15)"}}>
    <div class="col-md-6 col-lg-7" >
        <h4>AVT-200 (4G)</h4>
        <p style={{textAlign:"justify"}}> There are dedicated GPS tracking devices available in the market that you can attach to vehicles, or containers you want to track. These devices usually come with their own software or apps that allow you to monitor their location in real-time. AVT 200 (4G) provide the latest technology devices to save on data, battery consumption and provides following additional features.</p>
       <p><b>High-Speed Data :-</b>4G high-speed positioning system that delivers to customer fast and precise location tracking.</p>
      <p style={{textAlign:"justify"}}><b>GNSS for Location:-</b>The AVT200 receives satellite signals from the Global Navigation Satellite System (GNSS), which includes GPS and other systems like BeiDou (BDS). This determines its precise location.</p>
      <p style={{textAlign:"justify"}}><b>LBS and AGPS for Enhancement:–</b>It also utilizes Location-Based Services (LBS) and Assisted GPS (AGPS) to improve location accuracy.</p>
      <p style={{textAlign:"justify"}}><b>Better Connectivity:–</b>4G networks can support a higher number of connected devices in each area, handling increasing data demands more effectively.</p>
      <p style={{textAlign:"justify"}}><b>Precision Tracking:–</b>Combining GPS systems for more than 2.5m accuracy even in urban environments with high-rise interference.</p>
        <h5>Plan</h5>
        <ul class="btn-list d-flex">
        <li class="active">1 Year Plan</li>
        <li class="active" >2 Year Plan</li>
        <li class="active">3 Year Plan</li>
        </ul>
        <p>&#8377; <strong id="priceVal">3500</strong> <small class="d-inline">+GST</small> &nbsp;&nbsp;
        &#8377; <strong id="priceVal">6000</strong> <small class="d-inline">+GST</small> &nbsp;&nbsp;
        &#8377; <strong id="priceVal">7500</strong> <small class="d-inline">+GST</small></p>
      </div>
      <div class="col-md-6 col-lg-5 text-center"> <img src="../img/avt200.png" style={{width:"161px", height:"450px"}} class="gpsDevices img-fluid" alt="AVT 200" /> </div>
    </div>
  </div>
</section>
<section >
  <div class="container">
    <h2 class="title2 text-center mb-40 all-heading-line">Frequently Asked Questions</h2>
    <div class="row">
      <div class="col-md-6"> <img src="../img/faq.jpg" class="img-fluid"/> </div>
      <div class="col-md-6">
      <div class="accordion" id="AVTFAQ">
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingOne">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faq-1" aria-expanded="true" aria-controls="collapseOne">
      How can I track a GPS location?
      </button>
    </h2>
    <div id="faq-1" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p> There are dedicated GPS tracking devices available in the market that you can attach to vehicles, or containers you want to track. These devices usually come with their own software or apps that allow you to monitor their location in real-time. AVT provide the latest technology devices to save on data, battery consumption and provides precise tracking.</p>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwo">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-2" aria-expanded="false" aria-controls="collapseTwo">
      What is the range of a GPS tracker?
      </button>
    </h2>
    <div id="faq-2" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p>The range of a GPS tracker can vary significantly depending on several factors, including the type of tracker, the environment in which it's used, and any obstructions that may interfere with the GPS signal.</p>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-3" aria-expanded="false" aria-controls="collapseThree">
      Benefits of AVT GPS tracking devices?
      </button>
    </h2>
    <div id="faq-3" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p>AVAAL Vehicle Tracking devices are based on the latest technology to provide accurate data and the information can be accessed within the application on your mobile device and laptop for tracking multiple vehicles.</p>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-4" aria-expanded="false" aria-controls="collapseThree">
      What is the price of a GPS tracker in India?
      </button>
    </h2>
    <div id="faq-4" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p>The price of a GPS tracker in India can vary depending on several factors such as the brand, features, technology, and intended use of the tracker. Here are some approximate price ranges for GPS trackers available in India. </p>
            <p>GPS trackers specifically designed for vehicle tracking usually have more advanced features such as engine immobilization, fuel monitoring, and route optimization. Prices for vehicle GPS trackers can range from ₹3,000 to ₹15,000 or higher, depending on the brand and features.  </p>
            <p>In addition to the initial cost of the GPS tracker, some companies may also charge subscription fees for access to their tracking platform or services. These fees can vary depending on the features and level of service provided.  </p>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-5" aria-expanded="false" aria-controls="collapseThree">
      Does GPS tracker require SIM card?
      </button>
    </h2>
    <div id="faq-5" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p>Whether a GPS tracker requires a SIM card depends on the type of tracker and how it communicates its location data. Here are the common scenarios: </p>
            <p>Cellular GPS Trackers utilize cellular networks to transmit their location data to a central server or a smartphone app. These trackers typically require a SIM card to access the cellular network and transmit data. The SIM card provides the tracker with a unique phone number and allows it to establish a connection with the cellular network provider. Users may need to subscribe to a data plan for the SIM card to enable data transmission. </p>
      </div>
    </div>
  </div>
</div>          
</div>
</div>
</div>
</section>

<section class="bg-light">
  <div class="container">
    <h2 class="title2 text-dark-blue mb-5 text-center all-heading-line">Client's Feedback</h2>
    <div class="row">
      <div class="col-md-6">
        <div class="card shadow border-0 quote">
          <div class="card-body p-5">
            <p class="mb-5">Extremely satisfied with the GPS device order! The product exceeded my expectations, offering precise navigation and reliability. The ordering process was seamless, and delivery was prompt. Overall, a fantastic experience deserving of a 5-star rating. Highly recommend this product and service to others!"</p>
            <h6 class="title4 mb-1">Manoj Tiwari</h6>
            <p class="text-muted">CEO</p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card shadow border-0 quote">
          <div class="card-body p-5">
            <p class="mb-5">AVT Bharat Gps Tracker is well-designed and outstanding Build Quality.The device is easy to install and very excellent in connectivity , great product with on time installation service to track your truck, cars etc. <br/><br/></p>
            <h6 class="title4 mb-1">Roshan Tripathi</h6>
            <p class="text-muted">Fleet Manager</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="mobile-app">
  <div class="container">
  <h2 class="title2 text-white mb-5 text-center all-heading-line">Get Mobile apps on</h2>
    <div class="row">
                    <div class="col-sm-6 port-img"><img alt="" src="../img/port-final1.png"/></div>
                    <div class="col-sm-6 position-relative">
                        <div class="ios-btns text-center">                          
                            <a href="https://apps.apple.com/in/app/avt-bharat/id6505133993" target="_blank" rel="avt"><img alt="" src="../img/apple.png" /></a>
                            <a href="https://play.google.com/store/apps/details?id=com.avaal.avtapp" target="_blank" rel="avt"><img alt="" src="../img/play-store.png" /></a>
                        </div>
                        <div class="ios-btns text-center mt-20">
                            <img  alt=""  src="../img/avt-bharat-ios.png"/>
                            <img  alt=""  src="../img/avt-bharat-android.png"/>
                        </div>
                        <div class="bottom-img text-right"><img src="../img/avtbharat.png" alt="" /></div>
                    </div>
                </div>
  </div>
</section>
	
<section id="contact">
  <div class="container"  >
    <h2 class="title2 text-dark-blue mb-5 text-center all-heading-line">Contact Us Now</h2>
    <div class="row">
      <div class="col-md-6">
        <div class="row">
      <div class="col-md-6 form-group">
        Name <span style={{color:"red"}}>&nbsp;*</span>
        <input id="ContactName"  name="ContactName" type="text" required="required" maxLength={35} className="form-control" value={this.state.contactInfo.ContactName} onChange={this.changeCHandler} />
      </div>
      <div class="col-md-6 form-group"></div>
      <div class="col-md-6 form-group">
        Mobile No. <span style={{color:"red"}}>&nbsp;*</span>
      <input id="ContactMobile"  name="ContactMobile" type="text" required="required" maxLength={10} className="form-control" value={this.state.contactInfo.ContactMobile}  onChange={this.changeCHandler} />
      </div>
      <div class="col-md-6 form-group">
        Email <span style={{color:"red"}}>&nbsp;*</span>
      <input id="ContactEmail"  name="ContactEmail" type="text" required="required" maxLength={30} className="form-control" value={this.state.contactInfo.ContactEmail}  onChange={this.changeCHandler} />
      </div>
      <div class="col-md-12 form-group">
        Message <span style={{color:"red"}}>&nbsp;*</span>
      <textarea id="ContactMessage"  name="ContactMessage" type="text" required="required" className="form-control" value={this.state.contactInfo.ContactMessage}  onChange={this.changeCHandler} />
      </div>
      <div class="col-md-12 form-group mt-3">
        <button class="btn btn-primary msg-btn" onClick={this.onClickSendMessage}>Send Message</button>
      </div>
      </div>
      </div>
      <div class="col-md-6">
        <div class="row">
      <div class="col-lg-6">
            <div class="card border-0">
              <div class="card-body"> <img src="../img/location.png" class="mb-3" alt="Location"/>
                <p><strong>LOCATION</strong></p>
                <p class="mb-0">1104A, Welldone Techpark Gurugram, Haryana 122018 </p>
              </div>
            </div>
          </div>
      <div class="col-lg-6">
            <div class="card border-0">
              <div class="card-body"> <img src="../img/phone-call.png" class="mb-3" alt="Location"/>
                <p><strong>PHONE</strong></p>                
                <p class="mb-0">+91 8512031313</p>
         <p class="mb-0">0124 436 6313</p>
              </div>
            </div>
          </div>
      <div class="col-lg-6">
            <div class="card border-0">
              <div class="card-body"> <img src="../img/email.png" class="mb-3" alt="Location"/>
                <p><strong>EMAIL</strong></p>
         <p class="mb-0">sales@avaalbharat.com</p>
              </div>
            </div>
          </div>
      </div>
      </div>
    </div>
  </div>
</section>

<PublicFooter/>
<Modal isOpen={this.state.showLogin} >
            <div class="modal-header justify-content-center bg-white border-0">
                <h5 className='modal-title'>Login</h5>
                <button type="button" class="btn-close" onClick={this.closeLoginModal}></button>
                </div>
                <div class="modal-body">            
                <div class="row">
            <div className="" >
             <div className="form-group"> User Name
                <input id="UserName" autofocus="autofocus"   name="UserName" type="text" required="required" className="form-control" onChange={this.changeHandler} onKeyDown={this.handleUsernameKeyDown}></input>
              </div>
              <div className="form-group" > Password
                <input id="Password" name="Password" type={this.state.pVisible ? "text" : "password"} required="required" autoComplete="new-password"  className="form-control"
                onChange={this.changeHandler} onKeyDown={this.handlePasswordKeyDown}></input>
                <span onClick={() => this.setVisible()} style={{ position: "absolute", right: "20px",top: "65%",transform: "translateY(-50%)",cursor: "pointer",}}>
                {this.state.pVisible ? <i class="fas fa-eye-slash"></i> : <i class="fas fa-eye"></i>} </span>
              </div>
              <div className="text-center">
                <button type="submit" name="signin" id="signin" onClick={this.onClickLogin} className="btn btn-primary2 w-100 mt-2">Login</button>
                <p>{this.state.message}</p>
                <br/>
                <button id='ForgetPasswordButton' onClick={this.onClickForgetPassword}  style={{ background:"none", border:"none", color:'blue', cursor:"pointer", float:'right' }} title="Forget Password"> Forget Password?</button>
                <br/>
              </div>
          </div>
            </div>
            </div>             
</Modal>
<Modal isOpen={this.state.showForgetPassword} >
  
           <div class="modal-header justify-content-center bg-white border-0">
                <h5 className='modal-title'>Forget Password</h5>
                <button type="button" class="btn-close" onClick={this.closeForgetPassword}></button>
                </div>
                <div class="modal-body">    
                  <ForgetPassword/>        
                 </div>
</Modal>    
<Modal isOpen={this.state.showResetPassword} >
           
             
       </Modal>          
            <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>
    </>
      
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AvtHome/>);


export default AvtHome;